import { render, staticRenderFns } from "./SkewBand.vue?vue&type=template&id=dc530390&scoped=true"
import script from "./SkewBand.vue?vue&type=script&lang=ts"
export * from "./SkewBand.vue?vue&type=script&lang=ts"
import style0 from "./SkewBand.vue?vue&type=style&index=0&id=dc530390&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc530390",
  null
  
)

export default component.exports